/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import axiosInstance from '@/utils/axiosInstance';

export interface JobTableProps {
    onJobDataLoad: (data: any) => void;
    invisibleColumns: string[];
}

export const extractJobDetails = (jobList: any) => {
    return jobList.map((job: any) => {
        const detail = JSON.parse(job.detail);
        if (detail == null) {
            return {
                userId: job.userId,
                status: job.status,
                updatedAt: job.updatedAt,
                externalJobId: job.externalJobId,
                runId: job.runId,
                id: job.id,
                createdAt: job.createdAt,
            };
        }
        return {
            userId: job.userId,
            status: job.status,
            updatedAt: job.updatedAt,
            system: detail.system,
            anid: detail.anid,
            externalJobId: job.externalJobId,
            runId: job.runId,
            id: job.id,
            createdAt: job.createdAt,
        };
    });
};

export const fetchSystemSelectionData = async (productList: any, page: number) => {
    try {
        const response = await axiosInstance.get(`/crm/system-selection/${productList.currentRunId}/${page}`);
        if (response.data) {
            const data = response.data as {
                s4pcList: any[];
                anidList: any[];
                jobList: { content: any[]; last: any; number: any; size: any; totalElements: any; totalPages: any };
            };
            return data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('Error loading JSON data:', error);
    }
};

export const getAvatarProps = (status: string) => {
    switch (status) {
        case 'FAILED':
            return { icon: 'sys-cancel-2', colorScheme: 'Accent1' as const, size: 'XS' as const, title: 'Failed' };
        case 'RUNNING':
            return { icon: 'sap-icon://in-progress', colorScheme: 'Accent6' as const, size: 'XS' as const, title: 'Running' };
        case 'COMPLETED':
            return { icon: 'sap-icon://accept', colorScheme: 'Accent7' as const, size: 'XS' as const, title: 'Completed' };
        default:
            return { icon: 'sap-icon://in-progress', colorScheme: 'Accent6' as const, size: 'XS' as const, title: 'Running' };
    }
};

export const formatDate = (inputDateString: string) => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(inputDateString);
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: userTimeZone,
    };
    return date.toLocaleString('en-US', options);
};
